import { render, staticRenderFns } from "./Sticky.vue?vue&type=template&id=05401900&scoped=true&"
import script from "./Sticky.vue?vue&type=script&lang=ts&"
export * from "./Sticky.vue?vue&type=script&lang=ts&"
import style0 from "./Sticky.vue?vue&type=style&index=0&id=05401900&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05401900",
  null
  
)

export default component.exports